export const news = [
  {
    id: "news-01",
    title: "《星际迷航：远航》定档，科幻巨制引爆暑期档",
    date: "2026-10-12",
    category: "影视新闻",
    author: "西瓜影音编辑部",
    summary: "备受期待的科幻巨制《星际迷航：远航》正式宣布定档，超前的视觉概念与扎实的故事线让影片未映先热。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20spaceship%20fleet%20gliding%20through%20deep%20dark%20space%20warm%20orange%20nebula%20glow%20dramatic%20lighting%20film%20still%20aesthetic%20high%20detail%20atmospheric%20haze%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-01&orientation=landscape",
    content: [
      "备受影迷期待的科幻巨制《星际迷航：远航》今日正式宣布定档，将于下月登陆各大影院。作为一部高概念太空题材影片，该片从立项之初就吸引了大量关注。",
      "影片讲述了人类首艘远航舰队穿越虫洞、寻找新家园的故事。导演克里斯·诺兰在采访中表示，团队为了呈现真实的太空质感，做了大量的科学考据与视觉实验，「我们希望观众坐在影院里，真的相信自己漂浮在星海之中」。",
      "从此前曝光的预告来看，影片在视觉呈现上极具野心，星云、虫洞与巨型飞船的场面令人印象深刻。同时，故事并没有停留在视觉奇观，而是把镜头对准了船员之间的信任与抉择。",
      "有提前观影的业内人士评价，影片「在宏大与细腻之间找到了很好的平衡」。随着定档消息公布，相关话题迅速登上社交平台热搜，暑期档的票房竞争也将更加激烈。",
    ],
  },
  {
    id: "news-02",
    title: "2026 年暑期档观察：类型多元化成为最大趋势",
    date: "2026-10-10",
    category: "行业动态",
    author: "特约撰稿 林一",
    summary: "从科幻到现实题材，从动画到悬疑，今年暑期档的类型分布比往年更加均衡，观众的观影选择也更加多样。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20crowded%20cinema%20lobby%20with%20warm%20orange%20marquee%20light%20deep%20dark%20toned%20interior%20atmospheric%20glow%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-02&orientation=landscape",
    content: [
      "随着暑期档进入尾声，今年的市场表现呈现出明显的多元化特征。与以往某一种类型一枝独秀不同，今年科幻、悬疑、动画与现实题材几乎平分秋色。",
      "数据分析显示，观众对「类型混搭」的作品接受度显著提高。不少影片在传统类型框架中加入了新的叙事元素，既保留了商业性，又提供了新鲜感。",
      "业内人士认为，这种变化说明观众的审美正在成熟，单纯依赖特效或明星的影片越来越难以获得口碑。相反，故事扎实、情感真挚的作品更容易形成长线口碑。",
      "可以预见，未来内容竞争的焦点将从「谁更热闹」转向「谁更打动人」。对创作者而言，这既是挑战，也是机会。",
    ],
  },
  {
    id: "news-03",
    title: "深度影评：《长安夜行》如何重塑古装动作美学",
    date: "2026-10-08",
    category: "影评",
    author: "影评人 沈砚",
    summary: "《长安夜行》用一夜之间的追凶故事，把盛唐的繁华与人心的幽暗缝合在同一幅画卷里，成为近年来古装动作片的代表作。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20an%20ancient%20Chinese%20city%20at%20night%20with%20red%20lanterns%20and%20mist%20deep%20dark%20toned%20scene%20with%20warm%20orange%20glow%20atmospheric%20haze%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-03&orientation=landscape",
    content: [
      "《长安夜行》最让人难忘的，是它对「时间」的处理。整部影片压缩在一夜之间，灯火通明的长安城既是背景，也是角色的对手。",
      "影片的动作设计克制而精准，没有炫技式的长镜头堆砌，而是把每一次出刀都放进人物的情绪里。武打在这里不是为了展示力量，而是为了表达选择。",
      "更难得的是，影片在视觉上复刻了盛唐气象，却没有停留于奇观。灯会、夜市、坊墙，每一处细节都服务于「繁华之下暗流涌动」的主题。",
      "当黎明到来，主角守住的不只是城中百姓，还有一种早已被遗忘的道义。这或许正是《长安夜行》超越类型片的地方。",
    ],
  },
  {
    id: "news-04",
    title: "行业动态：流媒体平台加大原创内容投入",
    date: "2026-10-06",
    category: "行业动态",
    author: "西瓜影音编辑部",
    summary: "多家流媒体平台公布了新一年度的内容计划，原创剧集与电影成为投入重点，竞争进一步向内容质量倾斜。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20modern%20dark%20streaming%20studio%20control%20room%20with%20warm%20orange%20monitor%20glow%20deep%20dark%20toned%20interior%20atmospheric%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-04&orientation=landscape",
    content: [
      "在近日举行的行业论坛上，多家流媒体平台公布了未来一年的内容布局，原创剧集与原创电影成为关键词。",
      "与早期「以量取胜」的策略不同，如今平台更强调内容的差异化与品质感。多位负责人提到，用户的注意力越来越稀缺，只有真正的好故事才能留住观众。",
      "与此同时，平台也在尝试更多元的形式，包括短剧集、季播剧与纪录片，以满足不同场景下的观看需求。",
      "业内观察者认为，原创内容投入的加大，将为更多优秀创作者提供机会，也将推动整个行业向更健康的方向发展。",
    ],
  },
  {
    id: "news-05",
    title: "《沉默证人》曝最新预告，悬疑氛围拉满",
    date: "2026-10-04",
    category: "预告片",
    author: "西瓜影音编辑部",
    summary: "《沉默证人》发布最新预告片，冷峻的镜头语言与层层反转的叙事节奏，让这部犯罪悬疑片备受期待。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20rainy%20dark%20city%20street%20at%20night%20with%20warm%20orange%20streetlight%20glow%20deep%20dark%20toned%20scene%20atmospheric%20fog%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-05&orientation=landscape",
    content: [
      "犯罪悬疑片《沉默证人》今日发布最新预告片。短短两分钟里，冷峻的镜头、压抑的配乐和一闪而过的关键线索，迅速把观众带入紧张的氛围。",
      "预告中，刑警队长秦朗的独白贯穿始终：「有些真相，说出来的代价更大。」配合快速剪辑的画面，影片的核心张力被精准地传达出来。",
      "值得注意的是，预告片几乎没有交代完整的剧情，而是留下大量悬念，这种「留白式」的物料处理获得了不少网友的好评。",
      "影片此前已在多个影展进行展映，获得了不错的口碑。随着预告发布，观众对其正式上映的期待值进一步升高。",
    ],
  },
  {
    id: "news-06",
    title: "专访：《都市迷局》主创谈悬疑剧的叙事创新",
    date: "2026-10-02",
    category: "影视新闻",
    author: "特约撰稿 苏晓",
    summary: "在热播剧《都市迷局》收官之际，我们与主创团队聊了聊悬疑剧如何跳出套路，讲出更有质感的故事。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20dark%20city%20at%20night%20with%20lit%20office%20windows%20and%20warm%20orange%20glow%20deep%20dark%20toned%20scene%20atmospheric%20haze%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-06&orientation=landscape",
    content: [
      "《都市迷局》以「单元案 + 主线」的双线结构收获了广泛讨论。收官之际，主创团队接受了我们的专访。",
      "导演吴启明表示，团队在创作时最看重的不是「反转够不够多」，而是「人物动机是否成立」。「悬疑只是外壳，真正让观众留下来的是人。」",
      "编剧团队透露，剧中的每一个单元案件都对应着现实中某种社会议题，希望通过案件的推进，让观众在解谜之外获得更多思考。",
      "谈到未来的创作计划，主创们表示会继续在类型融合上做尝试，「我们不追求迎合，而是希望做出经得起反复观看的作品」。",
    ],
  },
  {
    id: "news-07",
    title: "盘点年度十大高分影视剧，口碑与热度双丰收",
    date: "2026-09-29",
    category: "影评",
    author: "西瓜影音编辑部",
    summary: "从科幻到现实题材，过去一年涌现出不少口碑与热度兼具的作品。我们整理了一份高分片单，供影迷收藏。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20cozy%20dark%20home%20theater%20with%20warm%20orange%20screen%20glow%20deep%20dark%20toned%20interior%20atmospheric%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-07&orientation=landscape",
    content: [
      "过去一年，影视市场既有商业大片的强势表现，也有中小成本作品的惊喜突围。我们综合评分与讨论热度，整理出这份年度高分片单。",
      "片单涵盖科幻、悬疑、家庭与现实等多种类型，既有《星际迷航：远航》这样的大制作，也有《山那边的家》这样细腻动人的小成本佳作。",
      "值得一提的是，越来越多作品开始关注普通人的情感与困境，这种「回到人本身」的创作取向，正成为高质量内容的重要标志。",
      "对观众而言，这无疑是一个好消息——选择更多，也更容易找到打动自己的那部作品。",
    ],
  },
  {
    id: "news-08",
    title: "动画电影崛起：国产动画如何讲好中国故事",
    date: "2026-09-26",
    category: "行业动态",
    author: "特约撰稿 陈屿",
    summary: "近年来国产动画电影在技术与叙事上持续进步，如何用现代语言讲好中国故事，成为创作者共同面对的课题。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20stylized%20ink%20painting%20mountains%20at%20dusk%20with%20warm%20orange%20glow%20deep%20dark%20toned%20atmospheric%20scene%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-08&orientation=landscape",
    content: [
      "从神话传说到现实题材，国产动画电影正在探索更宽广的表达空间。技术层面的进步有目共睹，而叙事上的突破同样值得关注。",
      "多位创作者在采访中提到，讲好中国故事的关键在于「找到共通的情感」，而不是简单堆砌传统文化符号。",
      "一些作品把水墨、剪纸等传统美学融入现代动画语言，形成了独特的视觉风格，也在国际影展上获得关注。",
      "可以预见，未来国产动画将继续在传统与当代表达之间寻找平衡，为观众带来更多惊喜。",
    ],
  },
  {
    id: "news-09",
    title: "《解码者》幕后特辑：科技题材的视觉呈现",
    date: "2026-09-23",
    category: "预告片",
    author: "西瓜影音编辑部",
    summary: "《解码者》发布幕后制作特辑，揭秘剧组如何用光影与构图，营造出冷峻而富有张力的科技氛围。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%20of%20a%20dark%20server%20room%20with%20warm%20orange%20status%20lights%20glowing%20deep%20dark%20toned%20scene%20atmospheric%20haze%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=450&seq=wm-news-09&orientation=landscape",
    content: [
      "热播剧《解码者》发布幕后特辑，带领观众走进这部科技悬疑剧的创作现场。",
      "摄影指导在特辑中介绍，团队刻意避免了炫目的「高科技感」，转而用克制的光线与大面积的暗部，营造出真实而压抑的氛围。",
      "美术团队则搭建了多个可供实拍的场景，从服务器机房到堆满代码的工位，每一处细节都经过反复推敲。",
      "主创表示，希望观众在紧张的剧情之外，也能感受到科技背后的人性温度，这正是《解码者》想要传达的核心。",
    ],
  },
];